/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGarageHomeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-garage-home"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.72 21.65Q4.17 21.65 3.79 21.26Q3.4 20.88 3.4 20.32L3.4 10.05Q3.4 9.43 3.69 8.86Q3.98 8.3 4.47 7.92L10.43 3.48Q10.78 3.2 11.18 3.08Q11.57 2.95 12 2.95Q12.43 2.95 12.82 3.08Q13.22 3.2 13.57 3.48L19.52 7.92Q20.02 8.3 20.31 8.86Q20.6 9.43 20.6 10.05L20.6 20.32Q20.6 20.88 20.21 21.26Q19.82 21.65 19.27 21.65L18.27 21.65Q17.73 21.65 17.34 21.26Q16.95 20.88 16.95 20.32L16.95 12.32Q16.95 11.78 16.56 11.39Q16.18 11 15.63 11L8.38 11Q7.83 11 7.44 11.39Q7.05 11.78 7.05 12.32L7.05 20.32Q7.05 20.88 6.66 21.26Q6.28 21.65 5.72 21.65ZM10 19Q9.57 19 9.29 18.71Q9 18.43 9 18L9 18Q9 17.57 9.29 17.29Q9.57 17 10 17L14 17Q14.43 17 14.71 17.29Q15 17.57 15 18L15 18Q15 18.43 14.71 18.71Q14.43 19 14 19ZM10 15Q9.57 15 9.29 14.71Q9 14.43 9 14L9 14Q9 13.57 9.29 13.29Q9.57 13 10 13L14 13Q14.43 13 14.71 13.29Q15 13.57 15 14L15 14Q15 14.43 14.71 14.71Q14.43 15 14 15Z" fill={color} />
    </svg>
  );
}
